import { createAction } from "@reduxjs/toolkit";


export const updateStepperState = createAction("UPDATE_STEPPER_STATE");

export const updateSegmentText = (id, text) => (dispatch) => {
  dispatch({
    type: "TRANSLATE/UPDATE_SEGMENT_TEXT",
    payload: {
      id: id,
      segmentText: text,
    },
  });
};


export const updateFileToDownload = (segments) => async (dispatch) => {
  dispatch({
    type: "DOWNLOAD/UPDATE_FILE_TO_DOWNLOAD",
    payload: { segments },
  });
};


